module.exports = __webpack_public_path__ + "img/hexagon.c04ce721.svg";